import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  // Adres jest względny wobec <base href> dokumentu — i taki musi zostać.
  // W wydaniu desktopowym index.html ładuje się z file://, gdzie „/i18n/pl.json"
  // wskazuje na katalog główny dysku, a nie na zasoby aplikacji. Transloco nie
  // dostawało wtedy żadnego pliku i renderowało same klucze („language.pl").
  getTranslation(lang: string) {
    return this.http.get<Translation>(`i18n/${lang}.json`);
  }
}
